let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("iB2zz"), load("ePOyH"), load("eacuJ"), load("cUtrS")]).then(() => parcelRequire('9dU2w'));